import React, { useState } from "react";

import { connect } from "react-redux";

import ExpandedRow from "./ExpandedRow";
import Row from "./Row";
import { selectInterivewById } from "../../../../redux/slices/interviewSlice";

/* =============================================================================
<InterviewResultsCandidatesTableRow />
============================================================================= */
const InterviewResultsCandidatesTableRow = ({ interview }) => {
  const [isRowExpended, setIsRowExpended] = useState(false);
  return (
    <>
      {isRowExpended ? (
        <ExpandedRow
          interview={interview}
          isRowExpended={isRowExpended}
          onExpand={() => setIsRowExpended(false)}
        />
      ) : (
        <Row
          interview={interview}
          isRowExpended={isRowExpended}
          onExpand={() => setIsRowExpended(true)}
        />
      )}
    </>
  );
};

const mapStateToProps = (state, { id }) => ({
  interview: selectInterivewById(state, id),
});

/* Export
============================================================================= */
export default connect(mapStateToProps)(InterviewResultsCandidatesTableRow);
